import { render, staticRenderFns } from "./calendre.vue?vue&type=template&id=8ddce0e6&scoped=true&"
import script from "./calendre.vue?vue&type=script&lang=js&"
export * from "./calendre.vue?vue&type=script&lang=js&"
import style0 from "./calendre.vue?vue&type=style&index=0&id=8ddce0e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddce0e6",
  null
  
)

export default component.exports